import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

import { QuickBooksComponent } from './quickbooks/quickbooks.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from 'app/core/core.module';
import { JournalEntryOverviewComponent } from './journal-entry-overview/journal-entry-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RouterModule.forChild([
            {
                path: 'quickbooks',
                canActivate: [PrepareGuard],
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    {
                        path: 'overview',
                        component: QuickBooksComponent,
                        data: { title: 'Overview' },
                        canActivate: [PrepareGuard, AuthGuard],
                    },
                    {
                        path: 'journal-entry-overview',
                        component: JournalEntryOverviewComponent,
                        data: { title: 'Journal Entry Overview' },
                        canActivate: [PrepareGuard, AuthGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [QuickBooksComponent, JournalEntryOverviewComponent],
})
export class QuickBooksModule {}
